module.exports = __webpack_public_path__ + "media/images/web_suite/resources_thumbs/featured-learn-site-thumbnail_zh-b421b9d6de0ee7de6621038ed3b710e0.png";